import moment from "moment";
import { FleetCardAssignment } from "../../../../../models/FleetExpenses/FleetExpensesModel";
import { OptionMap } from "../../../../../helpers/optionMap";

export const createCardAssignmentOptions = (
  assignments: FleetCardAssignment[]
): OptionMap<string> =>
  new OptionMap<string>(
    assignments.reduce((options, assignment) => {
      const startsAt = moment(assignment.starts_at).format("YYYY-MM-DD HH:mm");
      const endsAt = assignment.ends_at
        ? moment(assignment.ends_at).format("YYYY-MM-DD HH:mm")
        : "Current";
      options[
        assignment.id.toString()
      ] = `${assignment.card.number} (${startsAt} - ${endsAt})`;
      return options;
    }, {} as Record<string, string>)
  );
